(function(Manogi, $, undefined) {

    //Private

    var slug_replacements = {
        'ä':'ae', 'ö':'oe', 'ü':'ue', 'ß':'ss', 'á':'a', 'à':'a', 'â':'a', 'ú':'u', 'ù':'u', 'û':'u', 'ó':'o', 'ò':'o', 'ô':'o', ' ':'-', '_':'-'
    }
    var slug_ok = 'abcdefghijklmnopqrstuvwxyz1234567890-.';




    //Public

    Manogi.lang = $('html').attr('lang');

    numeral.language(Manogi.lang);

    Manogi.config = {};

    Manogi.windowTop = 0;

    Manogi.slugReplacements = {
        'ä' : 'ae',
        'á,à,â' : 'a',
        'ö' : 'oe',
        'ó,ò,ô' : 'o',
        'ü' : 'ue',
        'ú,ù,û' : 'u',
        'ß' : 'ss'
    };

    $('#config > div').each(function(){
        Manogi.config[$(this).data('key')] = $(this).html();
        if($(this).data('type') == 'int'){
            Manogi.config[$(this).data('key')] = parseInt(Manogi.config[$(this).data('key')]);
        }
        if($(this).data('type') == 'boolean'){
            Manogi.config[$(this).data('key')] = Boolean(Manogi.config[$(this).data('key')]);
        }
    });



    Manogi.currentBodyY = 0;

    Manogi.domainPath = window.location.protocol+'//'+window.location.hostname;

    Manogi.isScrolledIntoView = function(elem)
    {
        var $elem = $(elem);
        var $window = $(window);

        var docViewTop = $window.scrollTop();
        var docViewBottom = docViewTop + $window.height();

        var elemTop = $elem.offset().top;
        var elemBottom = elemTop + $elem.height();

        return (((elemTop <= docViewBottom) && (elemTop >= docViewTop)) || ((elemBottom <= docViewBottom) && (elemBottom >= docViewTop)));
    }

    Manogi.getBgImg = function($element) {
        var img =  $element.css('background-image').replace(/^url\(['"]?/,'').replace(/['"]?\)$/,'');
        return(img);
    };




    Manogi.scrollToElement = function($element) {
        var top = $element.offset().top-70;
        $('html, body').animate({scrollTop:top}, 700);
    }

    Manogi.fixBody = function(){

    }
    Manogi.unfixBody = function(){

    }

    Manogi.translate = function(slug){
       return $('.u-translation[data-slug="'+slug+'"]').text();
    }
    Manogi.setting = function(slug){
       return $('.u-setting[data-slug="'+slug+'"]').text();
    }

    Manogi.disableButton = function($button){
       $button.prop('disabled', true);
       $button.attr('disabled', 'disabled');
    }

    Manogi.enableButton = function($button){
       $button.prop('disabled', false);
       $button.removeAttr('disabled');
    }

    Manogi.selectOption = function($option){
       var $select = $option.closest('select');
       $select.find('option').prop('selected', false);
       $select.find('option').removeAttr('selected');
       $option.prop('selected', true);
       $option.attr('selected', true);
       $select.val($option.val());
    }

    Manogi.removeHash = function () {
        var scrollV, scrollH, loc = window.location;
        if ("pushState" in history)
            history.pushState("", document.title, loc.pathname + loc.search);
        else {
            // Prevent scrolling by storing the page's current scroll offset
            scrollV = document.body.scrollTop;
            scrollH = document.body.scrollLeft;

            loc.hash = "";

            // Restore the scroll offset, should be flicker free
            document.body.scrollTop = scrollV;
            document.body.scrollLeft = scrollH;
        }
    }

    Manogi.showLoading = function () {
        $('.loading').addClass('is-visible');
    }
    Manogi.hideLoading = function () {
        $('.loading').removeClass('is-visible');
    }


}( window.Manogi = window.Manogi || {}, jQuery ));
